import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function ReportPrintingEditForm({
  schoolReport,
  btnPrintRef,
  sendToPrint
 }) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={schoolReport}
      onSubmit={(values) => {
        sendToPrint(values);
      }}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="plannedPrintDate">
            <Form.Label column sm={2}>
              Basılma Tarihi<span> *</span>
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="datetime-local" value={values.plannedPrintDate} placeholder="Basılma Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnPrintRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}